export default {
  setCrazyEggUserVariable ({ userId, professionName, yearLevelName, roleLabel, prakerjaStatus }) {
    /* global CE2 */
    /* eslint no-undef: "error" */
    window.CE_READY = function () {
      if (CE2) {
        CE2.set('1', userId)
        CE2.set('2', professionName)
        CE2.set('3', yearLevelName)
        CE2.set('4', roleLabel)
        CE2.set('5', prakerjaStatus)
      }
    }
  }
}
